import { render, staticRenderFns } from "./A-1_AboutUs.vue?vue&type=template&id=cd83f57c&"
import script from "./A-1_AboutUs.vue?vue&type=script&lang=js&"
export * from "./A-1_AboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
